import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appDecimalNumberOnly]',
    standalone: false
})
export class DecimalNumberOnlyDirective {
  
  @Input('numericType') numericType: string; // number | decimal

private regex = {
    number: new RegExp(/^\d+$/),
    decimal: new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g),
    textOnly: new RegExp(/^[A-Za-z]+$/),
    textWithNumber: new RegExp(/^[A-Za-z]+[0-9]+(\.[0-9]*){0,1}$/),
    textWithSpecialChars:new RegExp(/^[A-Za-z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]*$/i)
};

private specialKeys = {
    number: [ 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete' ],
    decimal: [ 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete' ],
    textOnly: [ 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete' ],
    textWithSpecialChars: [ 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete' ],
    textWithNumber: [ 'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete' ]
};

constructor(private el: ElementRef) {
}

@HostListener('keydown', [ '$event' ])
onKeyDown(event: KeyboardEvent) {

    if (this.specialKeys[this.numericType].indexOf(event.key) !== -1) {
        return;
    }
    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex[this.numericType])) {
        event.preventDefault();
    }
}
}